import FactoryComponents from '../../../../../../factory/components/FactoryComponents.js';

const root = {}
export default root
root.name = 'processThree';
root.props = {processData: Object, deptDatas: Array, userDatas: Array, thisId: Number, success: Function};
root.data = {
    dangerGovernData: {
        cacheData: {},
    },
    buildingAfterPic: '',
}
root.methods = {
    handleAvatarSuccess2(res, file) {
        // console.log(res)
        this.buildingAfterPic = file.response.data
    },

    //提交整改
    successApproval: function () {
        if (this.dangerGovernData.cacheData.rectifyTime == null) {
            this.$message({
                message: '请选择整改时间',
                type: 'error'
            });
            return;
        }
        const that = this;
        const formData = new FormData();
        formData.append("id", this.processData.approveInfoVo.id);
        formData.append("rectifyTime", this.dangerGovernData.cacheData.rectifyTime);
        formData.append("rectifyOpinion", this.dangerGovernData.cacheData.rectifyOpinion);
        formData.append("hiddenGovernId", this.processData.id);
        formData.append("buildingAfterPic", this.buildingAfterPic);
        this.componentsMoudel.startPost('/approveInfo/update', formData, true).then(res => {
            that.success(that.processData, 2);
        })
    },


}

root.watch = {
    processData: function (newProcessData, oldProcessData) {
        if (newProcessData.approveInfoVo && newProcessData.approveInfoVo !== null) {
            this.dangerGovernData.cacheData = {...this.processData.approveInfoVo}
        }
    }
}

FactoryComponents.initComponent(root);